import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import { api } from "@/lib/api";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
};

export default function Journal() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/journal").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader label="Journal" title="UPDATES FROM THE PROJECT">
        Progress, breeding updates, business notes and lessons learned — written as it happens.
      </PageHeader>

      <section className="pb-28" data-testid="journal-list">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          {loading ? (
            <p className="text-brand-textMuted">Loading…</p>
          ) : posts.length === 0 ? (
            <p className="text-brand-textMuted">No posts yet. Check back soon.</p>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.08}>
                  <Link to={`/journal/${p.slug}`} className="group block card-surface overflow-hidden h-full" data-testid={`journal-card-${p.slug}`}>
                    <div className="relative aspect-[16/10] overflow-hidden">
                      {p.cover_image ? (
                        <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                      ) : (
                        <div className="w-full h-full bg-brand-elevated" />
                      )}
                      {p.is_sample && (
                        <span className="absolute top-3 right-3 text-[10px] uppercase tracking-wider bg-brand-base/70 backdrop-blur text-brand-textSec px-2.5 py-1 rounded-full">
                          Sample
                        </span>
                      )}
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-3 text-xs">
                        <span className="text-brand-cyan uppercase tracking-wider">{p.category}</span>
                        <span className="text-brand-textMuted">{fmtDate(p.created_at)}</span>
                      </div>
                      <h3 className="mt-3 font-display font-semibold text-white text-lg leading-snug group-hover:text-brand-cyan transition-colors">
                        {p.title}
                      </h3>
                      <p className="mt-2 text-brand-textSec text-sm leading-relaxed line-clamp-3">{p.excerpt}</p>
                      <span className="mt-4 inline-flex items-center gap-2 text-brand-cyan text-sm font-medium">
                        Read update <ArrowRight size={15} />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
